import { HttpRequest } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export const XSRF_HEADER = 'x-xsrf-token';

export interface AuthHeaderValues {
	token: string | null;
	xsrfToken: string | null;
}

/**
 * SINGLE source of truth for how an authenticated API request is decorated.
 *
 * Two paths dispatch to the backend: JwtInterceptor (normal) and
 * ErrorInterceptor.handle401 -> addToken (post-refresh retry). ErrorInterceptor
 * is registered AFTER JwtInterceptor (app.module.ts:34-36) and is therefore the
 * innermost interceptor: its next.handle() reaches HttpBackend directly and
 * JwtInterceptor never re-runs on that retry. Any header policy that lives only
 * in JwtInterceptor is silently absent on the second path — that is the bug
 * this function exists to make structurally impossible.
 *
 * Callers own the `isApiUrl` gate; this function assumes it has been applied.
 */
export function withAuthHeaders<T>(request: HttpRequest<T>, { token, xsrfToken }: AuthHeaderValues): HttpRequest<T> {
	const setHeaders: Record<string, string> = {};
	if (token) {
		setHeaders['Authorization'] = `Bearer ${token}`;
	}
	if (environment.cookieAuth && xsrfToken) {
		setHeaders[XSRF_HEADER] = xsrfToken;
	}
	return request.clone({
		setHeaders,
		...(environment.cookieAuth ? { withCredentials: true } : {})
	});
}
